import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { FcSms, FcMoneyTransfer, FcOrgUnit, FcMenu , FcMultipleSmartphones,FcUpload,FcFaq,FcSimCardChip,FcManager,FcEngineering,FcCollect} from "react-icons/fc"; 
import { RiMoneyDollarBoxLine } from "react-icons/ri";
import { BsChatLeftDots ,BsCashStack} from "react-icons/bs";
import { IoWalletOutline } from "react-icons/io5";
import { FaMoneyBillTransfer, FaAward } from "react-icons/fa6";
import { CgUserList } from "react-icons/cg";
import { FiUsers } from "react-icons/fi";
import HandleCurrentPath from "./HandleCurrentPath";
const MobileHamburger = () => {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const toggleSideMenu = () => {
    setIsSideMenuOpen(!isSideMenuOpen);

  }; 
    const closeSideMenu = () => {
        setIsSideMenuOpen(false);
    };
    const pathname = window.location.pathname;
    const [clientMgtOpen, setClientMgtOpen] = useState(false);
    const [smsOpen, setSmsOpen] = useState(false);
    const [transactionsOpen, setTransactionsOpen] = useState(false);
    const [userMgtOpen, setUserMgtOpen] = useState(false);
    const [salesMgtOpen, setSalesMgtOpen] = useState(false);
    const [productMgtOpen, setProductMgtOpen] = useState(false);
  
  return (
    <>
     {/* Mobile menu */}

     <aside
                className={`fixed inset-y-0 z-20 flex-shrink-0 w-64 mt-16 overflow-y-auto bg-white dark:bg-gray-800 md:hidden ${isSideMenuOpen ? 'block' : 'hidden'}`}
                onClick={closeSideMenu}
            >
                <div className="py-4 text-gray-500 dark:text-gray-400">
          <Link
            className="ml-6 text-lg font-bold text-gray-800 dark:text-gray-200"
            href="#"
          >
           SolarTrax
          </Link>
          <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Dashboard</span>
                </Link>
                </li>
            </ul>
          <ul className="mt-6">
           
          <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/cpanel'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/cpanel'} >
                <BsCashStack/>
                <span className="ml-4">Control Panel </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/client'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/client'} >
                <FcManager/>
                <span className="ml-4">Client List</span>
            </Link>
        </li>
        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/clientBalances'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/clientBalances'} >
                <FcEngineering/>
                <span className="ml-4">Client Balances </span>
            </Link>
        </li>

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/packageitem'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/packageitem'} >
                <RiMoneyDollarBoxLine/>
                <span className="ml-4">Package Items</span>
            </Link>
        </li>    

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/solarpackage'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/solarpackage'} >
                <FcCollect/>
                <span className="ml-4">Solar Packages </span>
            </Link>
        </li>
   

        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/packageinstallation'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/packageinstallation'} >
                <CgUserList/>
                <span className="ml-4">Package Installation</span>
            </Link>
        </li>



        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/deposit'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/deposit'} >
                <FcMoneyTransfer/>
                <span className="ml-4">Deposits </span>
            </Link>
        </li>



        <li className="relative px-6 py-3">
            <HandleCurrentPath staticPath={'/interactiveSms'} currentPath={pathname} />
            <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/interactiveSms'} >
                <FcSms/>
                <span className="ml-4">InteractiveSms </span>
            </Link>
        </li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/smsMessage'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/smsMessage'} >
         <BsChatLeftDots/>
         <span className="ml-4">Bulk Out</span>
     </Link>
</li>


<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebook'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebook'} >
         <FcMultipleSmartphones/>
         <span className="ml-4">Phonebooks </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/phonebookupload'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/phonebookupload'} >
         <FcUpload/>
         <span className="ml-4">Upload Contacts </span>
     </Link>
</li>
<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/bulkbroadcast'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/bulkbroadcast'} >
         <FcFaq/>
         <span className="ml-4">Bulkbroadcast </span>
     </Link>
</li>

<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/senderid'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/senderid'} >
         <FcSimCardChip/>
         <span className="ml-4">Senderid </span>
     </Link>
</li>





<li className="relative px-6 py-3">
     <HandleCurrentPath staticPath={'/b2ctopup'} currentPath={pathname} />
     <Link className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200" to={'/b2ctopup'} >
         <FaMoneyBillTransfer/>
         <span className="ml-4">B2C Top Up </span>
     </Link>
</li>
 
   

          </ul>
          </div>

            </aside>
            {/* End mobile Menu */}
    <button
      className={`p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-purple ${isSideMenuOpen ? 'bg-purple-500' : 'bg-transparent'}`}
      onClick={toggleSideMenu}
      aria-label="Menu"
    >

        <FcMenu/>
      {/* <svg
        className="w-6 h-6 text-white"
        aria-hidden="false"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
          clipRule="evenodd"
        />
      </svg> */}
    </button>
    </>
    
  );
};

export default MobileHamburger;